import { base } from "./base";
import { errorToastHook } from "./hooks/errorToast";
import { loaderEndHook, loaderErrorHook, loaderStartHook } from "./hooks/loader";
import { localTokenRefreshHook } from "./hooks/tokenRefresh";
import { makeAuthHook } from "./hooks/auth";

const localAuthHook = makeAuthHook(() => localStorage.getItem("token"));

// Authenticated — loader + auth + 403 refresh
export const httpAuth2 = base.extend({
  hooks: {
    afterResponse: [loaderEndHook, localTokenRefreshHook],
    beforeError: [loaderErrorHook, errorToastHook],
    beforeRequest: [loaderStartHook, localAuthHook],
  },
});
